import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked", "disabled", "value"]



type Value = string | number | boolean
type Option = {
    value: Value
    label: string
}
interface Props {
    disabled?: boolean
    option: Option
    active: boolean
    alignClass?: 'align-items-center' | 'align-items-start' | 'align-items-end'
}
interface Emits {
    (e: 'radioClick', option: Option): void
}

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'Radio',
  props: {
    disabled: { type: Boolean },
    option: {},
    active: { type: Boolean },
    alignClass: {}
  },
  emits: ["radioClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// emits
const emit = __emit

// handlers
const handleClick = (e: any) => {
    if (!props.disabled) emit('radioClick', props.option)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "button",
    class: _normalizeClass(["d-flex flex-row nowrap", _ctx.alignClass || 'align-items-center']),
    style: {"gap":"5px"}
  }, [
    _createElementVNode("input", {
      role: "button",
      checked: props.active,
      class: "ts-form-check-input my-1",
      disabled: props.disabled,
      type: "radio",
      value: props.option?.value,
      onChange: handleClick
    }, null, 40, _hoisted_1),
    _createElementVNode("label", {
      role: "button",
      onClick: handleClick
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(props.option?.label || ''), 1)
      ])
    ])
  ], 2))
}
}

})